module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productCockroach"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 2
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 3
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(3)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 4
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(4)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌 (典雅版)\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            全新天然木紋包裝專為時尚家居而設，連環殺滅功能，將巢穴內的曱甴一網打盡！\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": require("../assets/productCockroach-section2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            配方專為曱甴而設，連環殺滅功能，有效針對家居曱甴問題！\n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": require("../assets/productCockroach-section3-product.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-gel page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 專業強效曱甴凝膠餌劑\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": require("../assets/productCockroach-sectionGel-product.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-3 page"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(4), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/aimIcon.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效殺蟻藥餌")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-4 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('div', {
    ref: "cockroach_1",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/about-section1-m.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 0)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    ref: "cockroach_2",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/about-section1-m.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2 section3"
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 1)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    ref: "cockroach_gel",
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/about-section1-m.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section2 sectionGel"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0, 2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index, 2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section-suggest"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(11), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/aimIcon.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效殺蟻藥餌")])])], 1)])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      active: _vm.openOverlay
    }
  }, [_c('div', {
    staticClass: "overlayBg",
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "srcset": _vm.crossBtn + ' 2x'
    },
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab tabChannel",
    class: {
      active: _vm.tabIndex === 0
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [(_vm.curProduct != 2) ? _c('div', {
    staticClass: "shoplist welcomeShopLink"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/welcome.jpg")
    }
  }), _vm._v(" "), _vm._m(13)]) : _vm._e(), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'full': _vm.curProduct == 2
    }
  }, [(_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(17), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(19), _vm._v(" "), _vm._m(20)]) : _vm._e(), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.curProduct != 2) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(22), _vm._v(" "), _vm._m(23)]) : _vm._e(), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), (_vm.curProduct !== 0) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(26), _vm._v(" "), _vm._m(27)]) : _vm._e(), _vm._v(" "), (_vm.curProduct !== 2) ? _c('div', {
    staticClass: "shoplist row"
  }, [_vm._m(28), _vm._v(" "), _vm._m(29)]) : _vm._e(), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), (_vm.curProduct == 1) ? _c('p', [_vm._v("*部分產品只限指定門市有售貨")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab tabInfo",
    class: {
      active: _vm.tabIndex === 1
    }
  }, [_vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist text-md-right"
  }, [(_vm.curProduct == 0) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/productCockroach-section2-1.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": require("../assets/productCockroach-section3-product-1.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": require("../assets/productCockroach-sectionGel-product.png")
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopInfo"
  }, [(_vm.curProduct == 0) ? _c('span', [_vm._v("\n                    藥餌數目: 6件裝"), _c('br'), _vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('span', [_vm._v("\n                    藥餌數目: 9件裝"), _c('br'), _vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('span', [_vm._v("\n                    有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                    生產地: 韓國"), _c('br'), _c('br')]) : _vm._e(), _vm._v("\n                  優點: "), _c('br'), _vm._v(" "), (_vm.curProduct == 0) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("天然木紋設計,不影響外觀，適合放置於時尚家居。")]), _vm._v(" "), _c('li', [_vm._v("特別依據曱甴角度設計的餌盒, 令曱甴更容易進出餌盒進食藥餌。")]), _vm._v(" "), _c('li', [_vm._v("連環殺滅功能，將巢穴裡面曱甴一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("成份無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("餌盒設計不容易令小孩或寵物直接觸及藥餌，安全有效。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("連環殺滅功能，將巢穴裡面曱甴一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("不弄污環境，使用方便。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])]) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("連環殺滅一點絕 殺曱甴")]), _vm._v(" "), _c('li', [_vm._v("5倍強效，連環殺滅")]), _vm._v(" "), _c('li', [_vm._v("可輕易深入隙縫及牆角，直達難以觸及的地方")]), _vm._v(" "), _c('li', [_vm._v("食物味藥餌可更有效殺滅曱甴")]), _vm._v(" "), _c('li', [_vm._v("容易吸引任何體積曱甴")]), _vm._v(" "), _c('li', [_vm._v("大大支，20克抵用裝")]), _vm._v(" "), _c('li', [_vm._v("3個月長效")]), _vm._v(" "), _c('li', [_vm._v("韓國製造")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab tabMethod",
    class: {
      active: _vm.tabIndex === 2
    }
  }, [_vm._m(34), _vm._v(" "), (_vm.curProduct == 0) ? _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethod), function(step) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName",
      domProps: {
        "innerHTML": _vm._s(step.text)
      }
    }, [_vm._v(_vm._s(step.text))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethodTwo), function(step) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName",
      domProps: {
        "innerHTML": _vm._s(step.text)
      }
    }, [_vm._v(_vm._s(step.text))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('div', {
    staticClass: "shoplistCol row"
  }, [_vm._m(35)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab tabWorks",
    class: {
      active: _vm.tabIndex === 3
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12 hidden-sm-down"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [(_vm.curProduct == 0) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/productCock-overlay-works.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 1) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/productCock-overlay-works2.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curProduct == 2) ? _c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/productCock-overlay-worksgel.png")
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.overlayWorks), function(work, index) {
    return (_vm.curProduct == 0) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.overlayWorks2), function(work, index) {
    return (_vm.curProduct == 1) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.overlayWorksGel), function(work, index) {
    return (_vm.curProduct == 2) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("想了解更多詳細威滅藥餌的殺滅的效用，請瀏覽"), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": '/preventiontips/insecticideguide'
    }
  }, [_vm._v("藥餌的殺滅效用")])], 1)])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "arrowContainer"
  }, [_c('div', {
    staticClass: "leftArrow",
    on: {
      "click": function($event) {
        _vm.previousOverlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow.png"),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rightArrow",
    on: {
      "click": function($event) {
        _vm.nextOverlayTab()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow.png"),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            配方專為曱甴而設，連環殺滅功能，可輕易"), _c('strong', [_vm._v("深入隙縫及牆角")]), _vm._v("，直達難以觸及的地方\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ant-suggest.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productCockroach-section2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌 (典雅版)\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          全新天然木紋包裝專為時尚家居而設，連環殺滅功能，將巢穴內的曱甴一網打盡！\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg section3Img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productCockroach-section3-product.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效曱甴藥餌\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          配方專為曱甴而設，連環殺滅功能，有效針對家居曱甴問題！\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "src": require("../assets/productCockroach-sectionGel-product.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 專業強效曱甴凝膠餌劑\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          配方專為曱甴而設，連環殺滅功能，可輕易"), _c('strong', [_vm._v("深入隙縫及牆角")]), _vm._v("，直達難以觸及的地方\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ant-suggest.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon1.png")
    }
  }), _vm._v("\n            銷售地點\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/wd2shop/zh/html/search/search-result.html?hs_srch_word=combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/parkinShop.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.parknshop.com/search?code=ALL&text=%E5%A8%81%E6%BB%85&searchField=%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/vanguard.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("華潤萬家*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/uselect.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("U-Select*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/aeon.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/yata.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田超市")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/apita.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": require("../assets/bamboos.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/hktvMall.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV Mall")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/ztore.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/pandamart.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/homeplus.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/healthstore.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/all_pharmacy.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/btn-pharmacylist.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon2.png")
    }
  }), _vm._v("\n            產品詳細資料\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon3.png")
    }
  }), _vm._v("\n            使用方法\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('ol', {
    staticClass: "methodList"
  }, [_c('li', [_vm._v("轉開餌劑蓋子")]), _vm._v(" "), _c('li', [_vm._v("\n                  任何罅隙、裂縫及陰暗位置「點」一下「專業強效曱甴凝膠餌劑」，(點狀或條狀皆可), 包括:\n                  "), _c('ul', [_c('li', [_vm._v("窗邊")]), _vm._v(" "), _c('li', [_vm._v("廚櫃罅隙")]), _vm._v(" "), _c('li', [_vm._v("雪櫃底")]), _vm._v(" "), _c('li', [_vm._v("鋅盤底的罅隙")]), _vm._v(" "), _c('li', [_vm._v("渠位附近")]), _vm._v(" "), _c('li', [_vm._v("排水位附近")]), _vm._v(" "), _c('li', [_vm._v("餐桌底暗角")])])]), _vm._v(" "), _c('li', [_vm._v("每平方公尺建議使用0.25克-0.5克。使用完記緊扭實蓋子。")]), _vm._v(" "), _c('li', [_vm._v("如發現凝膠餌劑體積變小，請酌量補加，以維持良好的滅蟲效果。")]), _vm._v(" "), _c('li', [_vm._v("請勿把噴霧殺蟲劑直接噴在藥餌上或其附近。")]), _vm._v(" "), _c('li', [_vm._v("定時每隔三個月更換一次藥餌，以達致長期最佳後果。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon4.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("連環殺滅功能")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f73ba52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductCockroach.vue
// module id = 236
// module chunks = 0